import { useMemo } from "react";

export const brandQuotes = [
  <span key="q1">You didn't stop being <span className="font-serif italic" style={{ color: "#C8C8F4" }}>her</span> when you became a mom.<br />You just needed better tools.</span>,
  <span key="q2">You've been doing it all on your own long enough.<br />It's time someone actually <span className="font-serif italic" style={{ color: "#C8C8F4" }}>helped.</span></span>,
  <span key="q3">It's not too late to get time back.<br /><span className="font-serif italic" style={{ color: "#C8C8F4" }}>It never was.</span></span>,
  <span key="q4"><span style={{ fontSize: "17px" }}>Somewhere under the school lunches and soccer schedules, she's still <span className="font-serif italic" style={{ color: "#C8C8F4" }}>in there.</span></span><br /> Let's go find <span className="font-serif italic" style={{ color: "#C8C8F4" }}>her.</span></span>,
  <span key="q5"><span style={{ fontSize: "18px" }}>You don't get a medal for doing everything the hard way.</span><br />You get burned out. Let's <span className="font-serif italic" style={{ color: "#C8C8F4" }}>fix that.</span></span>,
];

const BrandQuoteCard = ({ className = "" }: { className?: string }) => {
  const randomQuote = useMemo(() => brandQuotes[Math.floor(Math.random() * brandQuotes.length)], []);

  return (
    <div className={`w-full rounded-2xl bg-gradient-to-br from-kin-charcoal to-[#2C2A5A] px-6 py-5 short:py-4 text-center ${className}`}>
      <p className="font-display text-primary-foreground short:text-[18px]" style={{ fontSize: "20px", fontWeight: 400, letterSpacing: "-0.3px" }}>
        {randomQuote}
      </p>
      <p className="mt-1.5 font-body uppercase" style={{ fontSize: "11px", letterSpacing: "2px", fontWeight: 600, color: "rgba(200, 200, 244, 0.7)" }}>
        KINYOUDOITALL.COM
      </p>
    </div>
  );
};

export default BrandQuoteCard;
